<template>
  <div class="ts-h-screen ts-w-screen ts-flex ts-flex-col login-page">
    <div class="ts-flex ts-items-center ts-py-5 ts-bg-blue-500 ts-shadow-md">
      <h2 class="ts-my-0 ts-ml-4 ts-text-4xl ts-text-white ts-font-teko">SMARTOP SYSTEM</h2>
      <span class="ts-flex-grow"></span>
      <span class="ts-mr-4 ts-text-white ts-text-xl ts-font-teko">Version 1</span>
    </div>
    <div class="ts-flex-grow">
      <div class="ts-h-full ts-w-full ts-flex ts-items-center ts-justify-center">
        <div
          :class="domainName == 'nira-is' ? 'promotional-box-nira' : 'promotional-box'"
          class="promotional-box ts-mr-4 ts-shadow-md"
        ></div>
        <div class="ts-shadow-lg ts-p-4 ts-bg-white ts-w-64 ts-rounded login-box">
          <div class="ts-w-full ts-flex ts-justify-center">
            <img v-if="domainName == 'nira-is'" src="@/assets/nira-logo.jpg" alt width="99" />
            <img v-else src="@/assets/logo.png" alt width="99" />
          </div>
          <form @submit.prevent="login" class="margin-bottom-0">
            <div class="ts-mt-10">
              <div class="alert alert-danger fade show ts-mb-4" v-show="errorMessage != ''">{{ errorMessage }}</div>
              <div class="form-group ts-mb-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text ts-inline-flex ts-w-10 ts-justify-center ts-items-center">
                      <i class="fas fa-user"></i>
                    </span>
                  </div>
                  <input
                    type="text"
                    placeholder="Username"
                    class="form-control form-control-lg input-login"
                    :class="{ 'is-invalid': errors.has('user_name') }"
                    v-model="user_name"
                  />
                  <div class="invalid-feedback" v-if="errors.has('user_name')">{{ errors.first('user_name') }}</div>
                </div>
              </div>
              <div class="form-group ts-mb-4">
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text ts-inline-flex ts-w-10 ts-justify-center ts-items-center">
                      <i class="fas fa-key"></i>
                    </span>
                  </div>
                  <input
                    type="password"
                    placeholder="Password"
                    class="form-control form-control-lg input-login"
                    :class="{ 'is-invalid': errors.has('password') }"
                    v-model="password"
                  />
                  <div class="invalid-feedback" v-if="errors.has('password')">{{ errors.first('password') }}</div>
                </div>
              </div>
              <div class="ts-mt-8">
                <ts-button type="submit" class="btn btn-primary btn-block btn-lg" :waiting="loggingIn"
                  >Sign me in
                </ts-button>
              </div>
            </div>
          </form>
          <div class="ts-mt-16 ts-text-center ts-text-blue-500">
            <span>POWERED BY: TECHSTORE CREATIVE SOLUTIONS</span>
          </div>
        </div>
      </div>
    </div>
    <div class="ts-py-4 ts-font-semibold ts-text-lg ts-text-center ts-text-gray-700">
      <span>© 2019-{{ currentYear }} TECHSTORE. All rights reserved.</span>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import PageOptions from '../config/PageOptions.vue'

export default {
  name: 'Login',
  data() {
    return {
      user_name: null,
      password: null,
      errors: new Errors(),
      errorMessage: '',
      loggingIn: false,
      domainName: ''
    }
  },
  computed: {
    currentYear() {
      return moment().year()
    }
  },
  created() {
    this.domainName = window.location.href.substring(8, 15)
    PageOptions.pageEmpty = true
    document.body.className = 'bg-white'
  },
  beforeRouteLeave(to, from, next) {
    PageOptions.pageEmpty = false
    document.body.className = ''
    next()
  },
  methods: {
    async login() {
      this.errors = new Errors()
      this.errorMessage = ''
      this.loggingIn = true

      try {
        await this.$store.dispatch('login', {
          user_name: this.user_name,
          password: this.password
        })

        this.$router.push(this.$route.query.redirectTo || { name: 'home' })
      } catch (errorResponse) {
        if (errorResponse.errors) {
          this.errors = new Errors(errorResponse.errors)
        } else if (errorResponse.message) {
          this.errorMessage = errorResponse.message
        }
      }

      this.loggingIn = false
    }
  }
}
</script>

<style lang="scss" scoped>
.login-page {
  background-image: url('../assets/background.png');
  background-blend-mode: multiply;
  background-size: rgba(0, 0, 0, 0.05);
}

.login-box {
  width: 330px;
  min-height: 435px;
}

.input-login {
  border-top-right-radius: 6px !important;
  border-bottom-right-radius: 6px !important;
}

.promotional-box {
  @media (min-width: 992px) {
    width: 780px;
    height: 435px;
    background-image: url('../assets/login-bg.jpg');
    object-fit: cover;
  }
}
.promotional-box-nira {
  @media (min-width: 992px) {
    width: 780px;
    height: 435px;
    background-image: url('../assets/cover-image-nira.jpg');
    object-fit: cover;
  }
}
</style>
